import React from 'react';
import Responsive from 'react-responsive';

export const MaxResolutions = {
    Mobile: 768
};

export default class Screen {
    static get isMobile() {
        return window.screen.availWidth <= MaxResolutions.Mobile;
    }
}

export const Desktop = props => <Responsive {...props} minWidth={992} />;
export const Tablet = props => <Responsive {...props} minWidth={768} maxWidth={991} />;
export const Mobile = props => <Responsive {...props} maxWidth={767} />;
export const Default = props => <Responsive {...props} minWidth={768} />;




// WEBPACK FOOTER //
// ./Src/Shared/Helpers/Screen.js